module.exports = __webpack_public_path__ + "img/rongYu10.c55c53f4.png";